import styled from 'styled-components';

export const Container = styled.main`
	position: relative;
	min-height: calc(100vh - 14rem);
	padding: 7.5rem 0 0 0;
	${({ theme }) => theme.common.container};
`;

export const Nav = styled.nav`
	font-family: NotoSansKR-Bold;
	width: 100%;
	top: 0;
	left: 0;
	height: 7.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	column-gap: 2rem;
	color: ${({ theme }) => theme.color.gray_70};

	.dash {
		content: '';
		width: 1px;
		height: 30%;
		border-right: 1px dashed gray;
	}

	& > button:not(.dash) {
		cursor: pointer;
	}

	& > button {
		background-color: transparent;
		border: none;
		font-size: 16px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: normal;
		text-align: center;
		color: #707070;

		${({ disabled }) =>
			disabled
				? `
			filter: brightness(0.5); /* 밝기를 50%로 낮추어 어둡게 */
			cursor: not-allowed;
		`
				: null}
	}

	.selected,
	& > button:not(.dash):hover {
		color: ${({ theme }) => theme.color.orange};
	}
`;
